import React, { useEffect, useMemo, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { AddToPhotos } from '@mui/icons-material';
import { Close, Delete } from '@mui/icons-material';
import { Modal, IconButton } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import {Alert} from '@mui/material';
import COLOR from 'utils/constants/color';
import {Snackbar, TextField } from '@mui/material';

import styled from "styled-components";
import { Col, Row } from "antd";
import { find, get } from "lodash";
import { graphic_activity, graphic_data } from "utils/constants/graphic_org";
import { IMAGE_FILE_TYPE } from "utils/constants/enum";
import { Button, CircularProgress } from '@mui/material';
import { handleCreateOwnGraphicOrganizer, handleUpdateOwnGraphicOrganizer } from 'store/activities/thunks';
import { useCurrentUser } from 'store/users/selectors';

//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Components ---------------------

//  -- Constants ----------------------

const StyledTextField = muiStyled(TextField)(({ theme, hasBorder = true }) => ({
    '& .MuiInput-underline:before': {
        borderBottomColor: hasBorder ? 'black' : 'transparent',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
        borderBottomColor: hasBorder ? 'black' : 'transparent',
    },
    '& .MuiInput-underline:after': {
        borderBottomColor: hasBorder ? 'black' : 'transparent',
    },
    '& .MuiInputBase-root': {
        padding: '2px',
        width: '100%'
    },
    '& .MuiInputBase-input': {
        fontSize: 6,
        [theme.breakpoints.down('sm')]: {
            fontSize:2,
          },
    },
}));

const PlanWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: transparent;
  overflow: hidden;
`;

// const PlanContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   width: 90%;
//   height: 100%;
//   position: relative;
//   justify-content: center;
//   padding: 20px;
//   background-color: white;
//   justify-content: center;
//   align-items: center;
//   overflow: hidden;
// `;

const PlanContainer = styled.div`
  display: flex;
  flex-direction: column;
//   width: 90%;
  max-height: 100%;
  position: relative;
  justify-content: center;
  padding: 20px 100px;
  background-color: white;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin: 0px 20px;
  padding-left: 40px;
  padding-right: 40px;

    // @media only screen and (max-width: 1400px) {
    //     overflow:auto;
    //     overflow-x: hidden;
    // }
    // @media only screen and (max-width: 991px) {
    // display:unset;
    // max-height: 96%;
    // margin-bottom: 5%;
    // width:40%;
    // padding: 20px;
    // //    padding-bottom:45px;
    // }
    // @media only screen and (max-width: 500px) {
    //     width: 50%;
    // }
`;

const CloseBtn = styled.div`
  background-color: rgb(204, 80, 71);
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: absolute;
  top: 10px;
  right: 10px;
  color: white;
  z-index: 1;
`;

const Container = styled.div`
  display: flex;
`;

const PrintWrapper = styled.div`
  display: flex;
`;

const Images = styled.img`
 background-color: ${COLOR.white};
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  object-fit: cover;
//   height: 600px;
   max-height: 80vh;
    // max-height:100%;
    width:100%;

@media only screen and (max-width: 1500px) {
        // height: 90%;
        max-height: 80vh;
        width: 100%;
} 
`;

const ButtonContainer = styled.button`
  background-color: transparent;
  border: none;
  color: ${COLOR.black600};
  cursor: pointer;
  height: 40px;
  left: ${(p) => `${p.left}px`};
  outline: none;
  position: absolute;
  right: ${(p) => `${p.right}px`};
  top: 50%;
  transition: all 300ms ease;
  width: 40px;
  z-index: 1;
`;
const AnswerWindowWrapper = styled.div`
   position: relative;
   width: 100%;
`;
const FileUploadArea = styled.div`
    height: 100%;
    border: 1px dashed gray;
    padding: 5px 12px;
    min-height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
`;

const ImageContainer = styled.div`
    height: auto;
    flex: 1;
`;
const Column = styled(Col)`
display: flex;
    justify-content: center;
    align-items: center;
}
`;
const Text = styled.div`
    font-size: 12px;
`;
const UploadedImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
    position: absolute;
    cursor: pointer;
    padding:10px;
`;
const ImageModal = styled.div`
    left: 50%;
    max-width: 544px;
    padding: 0px 24px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
`;
const Image = styled.img`
    border: 1px solid ${COLOR.black800};
    width: 100%;
    height: auto;
`;
// function ImageUploader({  positions }) {
//     const [pagePoster, setpagePoster] = useState(null)
//     const max_height = positions.max_height ? { maxHeight: positions.max_height } : {};
//     const min_height = positions.min_height ? { minHeight: positions.min_height } : {};
//     return (
//         <ImageContainer onContextMenu={(e) => { }} style={{
//             position: 'absolute',
//             width: `calc(${positions.width} * 100%)`,
//             height: positions.height ? `calc(${positions.height} * 100%)` : '50px',
//             left: `calc(${positions.left} * 100%)`,
//             top: `calc(${positions.top} * 100%)`,
//             justifyContent: "center",
//             alignItems: 'center',
//             display: "flex",
//             ...max_height,
//             ...min_height
//         }}>
//              {pagePoster? <UploadedImage src={pagePoster}/>:null}
//                 <FileUploader
//                     handleChange={(file)=>{setpagePoster(URL.createObjectURL(file))}}
//                     name="file"
//                     types={fileTypes}

//                 >
//                 <FileUploadArea>
//                     <Row className="box box-1" style={{ display: "flex", gap: 4 }}>
//                         <Column >
//                             <AddToPhotos color="primary" />
//                         </Column>
//                         <Column>
//                             <Text>
//                                 Upload here
//                             </Text>
//                         </Column>
//                     </Row>
//                     <Row>
//                         <Text style={{ fontSize: 8 }}>
//                             {fileTypes.join(",")}
//                         </Text>
//                     </Row>

//                 </FileUploadArea>
//                 </FileUploader>
//         </ImageContainer>
//     )
// }

function ImageUploader({ positions,loaderImg }) {
    const [pagePoster, setpagePoster] = useState(null)
    const [modalOpen, setModalState] = useState(false)
    const handleDelete = () => {
        setpagePoster(null);
    };
    const max_height = positions.max_height ? { maxHeight: positions.max_height } : {};
    const min_height = positions.min_height ? { minHeight: positions.min_height } : { minHeight:"50px"};
    return (<>
        <Modal
            open={modalOpen}
            onClose={() => setModalState(false)}
            style={{ height: '100%', width: '100%' , zIndex:9999999999999}}
        >
            <ImageModal>
                <Image src={pagePoster} alt='' />
            </ImageModal>
        </Modal>
        <ImageContainer className={`${positions.class_name} scrollViewGrad`} onContextMenu={(e) => { }} style={{
            position: 'absolute',
            width: `calc(${positions.width} * 100%)`,
            height: positions.height ? `calc(${positions.height} * 100%)` : 'auto',
            left: `calc(${positions.left} * 100%)`,
            top: `calc(${positions.top} * 100%)`,
            ...max_height,
            ...min_height,
            justifyContent: "center",
            alignItems: 'center',
            display: "flex",
        }}>
            {pagePoster ? <>
                <UploadedImage onClick={() => setModalState(true)} src={pagePoster} />
                <IconButton color="secondary" style={{ position: "absolute", right: 6, top: -14 , zIndex:9999 , padding:0 }} onClick={handleDelete}
                ><Delete /></IconButton>
            </> :
                <FileUploader
                    handleChange={(file)=>{setpagePoster(URL.createObjectURL(file))}}
                    name="file"
                    types={IMAGE_FILE_TYPE}
                >
                    <FileUploadArea>
                        <Row className="box box-1" style={{ display: "flex", gap: 4 }}>
                            <Column >
                                <AddToPhotos color="primary" />
                            </Column>
                            <Column>
                                <Text>
                                    Upload here
                                </Text>
                            </Column>
                        </Row>
                        <Row>
                            <Text style={{ fontSize: 8 }}>
                                {IMAGE_FILE_TYPE.join(",")}
                            </Text>
                        </Row>

                    </FileUploadArea>
                </FileUploader>}
        </ImageContainer>
    </>)
}

const InputArea = ({ positions, value, onChange, index }) => {
    const hasBorder = typeof positions.bottom_border === "boolean" ? positions.bottom_border : true;
    const [internalValue, setInternalValue] = useState('');

    useEffect(() => {
        // Show placeholder as initial value for first input only, once
        if (!value) {
            setInternalValue('');
            onChange(index,  '');
        } else if (value !== undefined && value !== null) {
            setInternalValue(value);

        }
    }, [index, value, positions.placeholder]);

    if (positions.input_type === "image") {
        return <ImageUploader positions={positions} />;
    }

    const max_height = positions.max_height ? { maxHeight: positions.max_height } : {};
    const min_height = positions.min_height ? { minHeight: positions.min_height } : {};
    const height_value = positions.height ? { height: `calc(${positions.height} * 100%)` } : {};
    const width_value = positions.width ? { width: `calc(${positions.width} * 100%)` } : {};
    const top_value = positions.top ? { top: `calc(${positions.top} * 100%)` } : {};
    const paddingTop = positions.paddingTop ? { paddingTop: `calc(${positions.paddingTop} * 100%)` } : {};
    const left_value = positions.left ? { left: `calc(${positions.left} * 100%)` } : {};

    return (
        <StyledTextField
            className={`${positions.class_name} custom-scrollbar`}
            multiline={positions.text_length === "multi_line"}
            value={internalValue}
            onChange={(e) => {
                const newValue = e.target.value;
                setInternalValue(newValue);
                onChange(index, newValue);
            }}
            style={{
                position: 'absolute',
                overflow: "auto",
                alignItems: 'center',
                ...max_height,
                ...min_height,
                ...height_value,
                ...width_value,
                ...top_value,
                ...left_value,
                ...paddingTop,
                backgroundColor: positions.background_color || "",
            }}
            placeholder={positions.placeholder || ''}
            label=""
            hasBorder={hasBorder}
        />
    );
};

const AnswerWindow = ({ src, label_position, inputValues, setInputValues }) => {
    const handleInputChange = (index, value) => {
        const updatedValues = [...inputValues];
        updatedValues[index] = value;
        setInputValues(updatedValues);
    };

    return (
        <AnswerWindowWrapper className="inputAreaWrap">
            <Images src={src} />
            {label_position.map((input, index) => (
                <InputArea
                    key={index}
                    positions={input}
                    value={inputValues[index] || ''}
                    onChange={handleInputChange}
                    index={index}
                />
            ))}
        </AnswerWindowWrapper>
    );
};

const GraphicOrganizerEditPreview = ({
    open,
    setOpen,
    assignment,
    ownGraphicOrganizer = [],
    setTemplateType = () => null
}) => {
    const dispatch = useDispatch();
    const currentUser = useCurrentUser();
    
    const [alertSakeBar, setAlertSakeBar] = useState({
        open: false,
        message: "",
        severity: "success",
    });
    const [loading, setLoading] = useState(false);
    
    const pageId = useMemo(() => get(assignment, "assignment_page"), [assignment])
    const matchedObj = useMemo(() => find(graphic_activity, (obj) => obj.id == assignment?.id || obj.displayName == assignment?.displayName), [assignment])
    const label_position = useMemo(() => get(matchedObj, "label_position", []) || [], [assignment]);
    const currentPageResourse = useMemo(() => get(find(graphic_data, (obj) => obj.pageId == pageId), label_position?.length > 0 ? "edit_image_src" : "src"), [assignment])

    const input_position = useMemo(() => get(assignment, "input_position", []) || [], [assignment])

    const existingOrganizer = useMemo(() => {
        return find(ownGraphicOrganizer, org => org.graphic_org_id === assignment?.copy_of?.id || org.graphic_org_id === assignment?.id);
    }, [ownGraphicOrganizer, assignment]);

    const [inputValues, setInputValues] = useState(Array(label_position.length).fill(''));
    
    const hasAnyInput = useMemo(() => {
        return inputValues.some(value => value && value.trim() !== '');
    }, [inputValues]);

    const closeAlert = () => {
        setAlertSakeBar({ open: false, message: "", severity: "success" });
    };

    useEffect(() => {
        if (existingOrganizer && existingOrganizer.graphic_label) {
            const existingValues = Array(label_position.length).fill('');
            existingOrganizer.graphic_label.forEach(item => {
                if (item.field_index !== undefined && item.field_index < existingValues.length) {
                    existingValues[item.field_index] = item.value || '';
                }
            });
            setInputValues(existingValues);
        } else {
            const placeholderValues = label_position.map(pos => pos.placeholder || '');
            setInputValues(placeholderValues);
        }
    }, [existingOrganizer, label_position, open]);

    const handleSave = async () => {
        setLoading(true);
        
        const graphic_label = inputValues.map((value, index) => ({
            field_index: index,
            class_name: label_position[index]?.class_name,
            placeholder: label_position[index]?.placeholder,
            input_type: label_position[index]?.input_type,
            value: value
        }));

        const dataToSave = {
            graphic_label: graphic_label,
            graphic_org_id: assignment?.id,
            user_id: get(currentUser, 'id'),
            updated_at: new Date().toISOString()
        };

        for (const label of graphic_label) {
            if (!label.value) {
                setAlertSakeBar({
                    open: true,
                    message: "All instruction fields are required.",
                    severity: "error",
                });
                setLoading(false);
                return; // ✅ exits handleSave immediately
            }
        }

        

        if (!existingOrganizer) {
            dataToSave.id = uuidv4();
            dataToSave.created_at = new Date().toISOString();
        }

        try {
            let result;
            if (existingOrganizer) {
                result = await dispatch(handleUpdateOwnGraphicOrganizer(existingOrganizer.id, dataToSave));
            } else {
                result = await dispatch(handleCreateOwnGraphicOrganizer(dataToSave));
            }
            if (result.success) {
                setAlertSakeBar({
                    open: true,
                    message: existingOrganizer ? "Graphic organizer updated successfully!" : "Graphic organizer saved successfully!",
                    severity: "success",
                });
                setTemplateType('custom');
                setTimeout(() => {
                    setOpen(false);
                    setAlertSakeBar({
                        open: false,
                        message: "",
                        severity: "success",
                    });
                }, 2000);
            } else {
                setAlertSakeBar({
                    open: true,
                    message: "Failed to save graphic organizer. Please try again.",
                    severity: "error",
                });
            }
        } catch (error) {
            console.error("Error saving graphic organizer:", error);
            setAlertSakeBar({
                open: true,
                message: "An error occurred while saving.",
                severity: "error",
            });
        } finally {
            setLoading(false);
        }
    }

    // const onPageChange = (direction) => {
    //     if (direction === "right" && currentPageIndex < select_book_pages.length - 1) {
    //         setCurrentPageIndex(currentPageIndex + 1);
    //     } else if (direction === "left" && currentPageIndex > 0) {
    //         setCurrentPageIndex(currentPageIndex - 1);
    //     }
    // };
    return (
        <>
            <Modal
                open={open}
                onClose={() => {
                    setOpen(false);
                    setAlertSakeBar({
                        open: false,
                        message: "",
                        severity: "success",
                    });
                }}
                className={"lessonPlanPopUp lessonPlanPopUpCstm"}
                style={{
                    height: "100%",
                    width: "100%",
                    backgroundColor: "transparent",
                }}
            >
                <PlanWrapper>
                    <Snackbar
                        anchorOrigin={{ vertical: "top", horizontal: "center" }}
                        open={alertSakeBar.open}
                        autoHideDuration={3000}
                        onClose={closeAlert}
                        style={{ position: 'fixed', zIndex: 99999 }}
                    >
                        <Alert
                            onClose={() => {
                                setAlertSakeBar({ open: false, message: "" });
                            }}
                            severity={alertSakeBar.severity}
                        >
                            <strong>ALERT:</strong> {alertSakeBar.message}
                        </Alert>
                    </Snackbar>
                    <PlanContainer>
                        <CloseBtn
                            onClick={(e) => {
                                e.preventDefault();
                                setOpen(false);
                                setAlertSakeBar({
                                    open: false,
                                    message: "",
                                    severity: "success",
                                });
                            }}
                        >
                            <Close
                                style={{ color: "#fff", fontWeight: "bolder", fontSize: 25 }}
                            />
                        </CloseBtn>
                        {/* <ButtonContainer
                            ref={backBtnRef}
                            disabled={currentPageIndex === 0}
                            onClick={(e) => {
                                e.preventDefault();
                                onPageChange("left");
                            }}
                            left={8}
                        >
                            <ArrowBackIos style={{ fontSize: "40px" }} />
                        </ButtonContainer>
                        <ButtonContainer
                            ref={forwardBtnRef}
                            disabled={currentPageIndex >= select_book_pages.length - 2}
                            onClick={() => {
                                onPageChange("right");
                            }}
                            right={0}
                        >
                            <ArrowForwardIos style={{ fontSize: "40px" }} />
                        </ButtonContainer> */}
                        <Container>
                            <PrintWrapper>
                                <Row style={{ width: "100%", height: "100%", maxWidth: "100%", padding: 0, gutter: 4 }}>
                                    
                                    <Col lg={24} md={24} xl={24} xs={24} >
                                        <AnswerWindow 
                                            src={currentPageResourse} 
                                            label_position={label_position}
                                            inputValues={inputValues}
                                            setInputValues={setInputValues}
                                        />
                                        <div style={{ display: "flex", gap: 4, justifyContent: "flex-end", marginTop: 10 }}>
                                            <Button 
                                                onClick={handleSave} 
                                                variant="contained" 
                                                color="primary"
                                                disabled={!hasAnyInput || loading}
                                                startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                                            >
                                                {loading ?  'Saving...' : existingOrganizer ? 'Update' : 'Create'}
                                            </Button>
                                            <Button 
                                                onClick={() => {
                                                    setOpen(false);
                                                    setAlertSakeBar({
                                                        open: false,
                                                        message: "",
                                                        severity: "success",
                                                    });
                                                }} 
                                                variant="contained" 
                                                color="error"
                                                disabled={loading}
                                            >
                                                Cancel
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </PrintWrapper>
                        </Container>
                    </PlanContainer>
                </PlanWrapper>
            </Modal>
        </>
    );
};

export default GraphicOrganizerEditPreview;